"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.imageType = exports.dataType = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _image = require("./image-640.config");
var imageType = _propTypes["default"].shape({
  image: _propTypes["default"].string,
  altText: _propTypes["default"].string
});
exports.imageType = imageType;
var dataType = _propTypes["default"].shape({
  resourceType: _propTypes["default"].string,
  offset: _propTypes["default"].string,
  image: imageType,
  mobileFocusArea: _propTypes["default"].oneOf(_image.mobileFocusAreaClasses)
});
exports.dataType = dataType;